/**
 * Autohandler for the merge products button.
 * Needed to update the input with material IDs for the deferred component.
 *
 * Should be removed once we deprecate this functionality.
 *
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

var pricingFormSelector     = '[data-sw-pricing-form]';
var materialIdInputSelector = '[data-sw-material-row-material-id-input]';
var materialIdsDeferredAttr = 'data-sw-deferred-component-model-ids';
var triggerMergeModalEvent  = 'merge-products-button';

$(document).ready(function() {
  $('body').on('click', '[data-sw-merge-products]', function(e) {
    e.preventDefault();

    var modelIds = [];
    $(pricingFormSelector).find(materialIdInputSelector).each(function(index, item) {
      modelIds.push(item.value);
    });

    $('[' + materialIdsDeferredAttr + ']').attr(materialIdsDeferredAttr, modelIds.join());

    sw.trigger(triggerMergeModalEvent);
  });
});
